import React,{useEffect} from 'react';
import '../Assets/Additionalcss/Corpcss.css'
import corplogo from '../Assets/Images/corp logo.png'

function Corpnavbar({openSidebar}) {

    useEffect(()=>{

        document.getElementById("Corp-username").innerHTML=localStorage.getItem('username')
 
         document.getElementById("Corp-role").innerHTML=localStorage.getItem('Role')
 });

    return (
<div className='corp-navbar'>
        <div className='corp-nav-icon'>
            <i className='fa fa-bars'  onClick={openSidebar}></i>
        </div>

        <div className='corp-navbar-left'>
        <div className='corp-sidebar-img'>
            <img src={corplogo} alt="logo"/>&nbsp;&nbsp;
        </div>
        </div>

        <div className='corp-navbar-right'>
            <a href='#'>
            <i class="fa fa-user-circle" aria-hidden="true"></i>
            </a>
            <div className='corp-right-navbar'>
            <span id="Corp-username"></span>   
            (<span id="Corp-role"></span>)
            </div>
            
        </div>
    </div>
    );
}

export default Corpnavbar;